import { TrackingEventsV2 } from '@/analytics/eventsV2';
import { trackCustomEvent } from '@/analytics/Mixpanel';
import { Icon } from '@/new/components/icon';
import { Button } from '@/new/components/shadcn/button';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogTrigger,
} from '@/new/components/shadcn/dialog';

export function UploadExplainerModal() {
  return (
    <Dialog>
      <DialogTrigger asChild>
        <Button
          variant="ghost"
          className="text-xs text-blue-600 hover:text-blue-700 hover:underline"
          onClick={() => trackCustomEvent(TrackingEventsV2.FileHistoryOpenUploadExplainer)}
        >
          <Icon className="lucide--info size-3.5 text-blue-500" />
          Uploading vs Processing Documents
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>
            <Icon className="lucide--info h-4.5 w-4.5 text-blue-500" />
            Uploading vs Processing Documents
          </DialogTitle>
          <DialogDescription>Understanding the document workflow in Wexler</DialogDescription>
        </DialogHeader>

        <div className="space-y-4 text-sm text-gray-600">
          <div>
            <h4 className="mb-1.5 font-medium text-gray-800">1. Uploading Documents</h4>
            <p>
              When you upload documents to Wexler, whether from your computer or via an integration (e.g. Relativity),
              the files are uploaded to the platform but are not yet processed, they are "awaiting submission".
            </p>
          </div>

          <div>
            <h4 className="mb-1.5 font-medium text-gray-800">2. Documents Awaiting Submission</h4>
            <p>
              After uploading, your files sit in this "awaiting submission" state. You can remove any files you don't
              need, and upload additional files before proceeding to processing.
            </p>
          </div>

          <div>
            <h4 className="mb-1.5 font-medium text-gray-800">3. Processing Documents</h4>
            <p>
              When you're ready, click <span className="font-medium">"Process Documents"</span>. This starts a{' '}
              <span className="font-medium">Run</span>, where Wexler extracts facts, identifies entities, and analyses
              your files. You will get an email once the processing is complete.
            </p>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
